"use client"

// src/components/format-number.ts
var FormatNumber = {};

export {
  FormatNumber
};
//# sourceMappingURL=chunk-KAMZX2TK.mjs.map